import { useEffect, useState } from "react";
import { ApiClient } from "/api/client";
import {
  getDeliveryCityData,
  setLocation,
  fetchDomains,
} from "@/redux/action-creaters/location";
import { useDispatch, useSelector } from "react-redux";
import { showPopup } from "/redux/action-creaters/popup";
import { popupTypes } from "/redux/reducers/popupReducer";
import Icon from "/components/common/icon";
import { useDebounce } from "usehooks-ts";
import clsx from "clsx";
import styles from "./index.module.scss";
import { setLocationLogic } from "../../../utils/location";
import { useCartInitLogic } from "../../pages/personal/cart/useCartInitLogic";
import { MAIN_CITIES } from "../../../lib/edost/resolveEdostRegion";

export default function Location() {
  const dispatch = useDispatch();

  const [cityList, setCityList] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);
  const [q, setQ] = useState("");
  const debouncedQ = useDebounce(q, 500);

  const { domains } = useSelector((state) => state.location);

  const { updateCartLocation } = useCartInitLogic();

  useEffect(() => {
    if (Object.values(domains).length === 0) {
      dispatch(fetchDomains());
    }
  }, [domains]);

  useEffect(async () => {
    if (debouncedQ.length > 2) {
      setCityLoading(true);
      const { suggestions } = await ApiClient.dadata.getCityList(debouncedQ);
      setCityList(suggestions);
      setCityLoading(false);
    }
  }, [debouncedQ]);

  const selectCity = async (cityName, cityData = {}) => {
    if (typeof window !== "object") {
      return;
    }
    if (cityData?.region_with_type?.replace("г ", "") === cityName) {
      // eslint-disable-next-line no-param-reassign
      cityData = {};
    }

    if (window.location.pathname.includes("/personal/cart")) {
      updateCartLocation(cityName, cityData);
    } else {
      await dispatch(getDeliveryCityData(cityData, true));
      await dispatch(setLocation(cityName));

      setLocationLogic(cityName, cityData, domains);
    }
    dispatch(showPopup(popupTypes.none));
  };

  useEffect(() => {
    const popupElement = document.querySelector(`#cityForm`);
    if (popupElement) {
      const firstInput = popupElement.querySelector("input");
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, []);

  return (
    <>
      <h2>Выбор города</h2>

      <div className={styles.Search} id="cityForm">
        <input
          data-test="citySearchInput"
          placeholder="Поиск города"
          value={q}
          onChange={(event) => setQ(event.target.value)}
        />
        {cityLoading && (
          <span className={styles.Loader}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 50 50"
            >
              <path d="M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="0.5s"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          </span>
        )}
        {cityList.length === 0 && (
          <Icon id="search" stroke={"#9294A9"} strokeWidth={2} size={24} />
        )}
        {cityList.length > 0 && (
          <>
            <div
              className={styles.Close}
              onClick={() => setQ("")}
              aria-label="Очистить поиск города"
            >
              <Icon id="close" size={24} />
            </div>
            <ul>
              {cityList.map((city) => (
                <li
                  key={city.ID}
                  data-test="citySuggestion"
                  onClick={() =>
                    selectCity(
                      `${city.data.settlement ?? city.data.city}`,
                      city.data,
                    )
                  }
                >
                  {city.value}
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
      <div className={clsx(styles.Citys, "custom-scroll")}>
        <ul>
          {MAIN_CITIES.map((city) => (
            <li
              key={city}
              data-test="cityListItem"
              data-city={city}
              onClick={() => selectCity(city)}
            >
              {city}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
